import type { PaginatorResponse } from "./common";
import type { MediaCategoryModel } from "./media-category";
import type { ExpenseCurrencyEnum } from "./expense-invoice";

export interface EditorMediaKeywordModel {
    id: number;
    keyword: string;
    createdAt: Date;
}

export interface MediaModel{
    id: number;
    name: string;
    url: string;
    email: string;
    phone?: string;
    type: MediaTypeEnum;
    price: number;
    discountPrice: number;
    discount: number;
    discountStartDate?: Date;
    discountEndDate?: Date;
    isDiscountByEditor?: boolean;
    country: string;
    linkType: LinkTypeEnum;
    dr: number;
    da: number;
    pa: number;
    cf: number;
    tf: number;
    rd: number;
    si: number;
    traffic: number;
    createdDate: Date;
    isImported: boolean;
    active: boolean;
    isOffer: boolean;
    province: string;
    redactionField: RedactionFieldEnum
    maxAllowedLinks: number;
    language: string;
    categories?: MediaCategoryModel[];
    isSponsored: boolean;
    isFrontPage: boolean;
    duration?: DurationEnum;
    domaingAge: number;
    screenshot?: string;
    notes?: string;
    exampleUrl?: string;
    costPrice?: number;
    costPriceCurrency?: ExpenseCurrencyEnum;
    agencyPrice?: number;
    userPrice?: number;
    costCitationPrice?: number;
    agencyCitationPrice?: number;
    userCitationPrice?: number;
    costInsertionPrice?: number;
    benefitCostEur?: number;
    keywords?: string
    trafficHistory?: string
    ur?: number,
    top_countries?: string
    insertions?: number
    insertionPrice?: number
    isGoogleNews?: boolean
    obl?: number
    verified?: boolean;
    status?: MediaEditorStatusEnum;
    isVacationMode?: boolean;
    editorCreatedAt?: Date;
    editorUpdatedAt?: Date;
    editorFechaVerificacion?: Date;
    editorId?: number;
    editorHasLoggedIn?: boolean;
    isEmailManaged?: boolean;
    noExternalJournalists?: boolean;
    editorMediaKeywords?: EditorMediaKeywordModel[];
    // Lista de medios duplicados si existen otros medios con la misma URL
    duplicateMedias?: MediaModel[];
}



export interface MediaPaginatorResponse extends PaginatorResponse<MediaModel> {
}


export interface IMediaTableFilters {
    mediaId?: number ;
    name: string;
    url: string;
    searchTerm?: string;
    email: string;
    linkType: LinkTypeEnum | null;
    mediaType: MediaTypeEnum | null;
    categories: number[];
    country: string[];
    language: string;
    redactionField: RedactionFieldEnum | null;
    active: boolean | null;
    drMin: number | null;
    drMax: number | null;
    daMin: number | null;
    daMax: number | null;
    tfMin: number | null;
    tfMax: number | null;
    trafficMin: number | null;
    trafficMax: number | null;
    priceMin: number | null;
    priceMax: number | null;
    orderBy?: string;
    orderDirection?: 'asc' | 'desc';
    editorStatus?: MediaEditorStatusEnum | null;
  }

export enum RedactionFieldEnum {
  Getalink,
  Editor,
  Journalist,
}

export enum DurationEnum {
    Permanent = 0,
    TwelveMonths = 1,
    TwentyFourMonths = 2,
    ThirtySixMonths = 3,
}

export const DURATION_OPTIONS: {
    value: DurationEnum;
    label: string;
}[] = [
    {
        value: DurationEnum.Permanent,
        label: 'Permanente',
    },
    {
        value: DurationEnum.TwelveMonths,
        label: '12 Meses',
    },
    {
        value: DurationEnum.TwentyFourMonths,
        label: '24 Meses',
    },
    {
        value: DurationEnum.ThirtySixMonths,
        label: '36 Meses',
    },
];

export enum LinkTypeEnum {
    DoFollow = 0,
    NoFollow = 1,
    Sponsored = 2,
}

export const LINK_TYPE_OPTIONS: {
    value: LinkTypeEnum;
    label: string;
}[] = [
    {
        value: LinkTypeEnum.DoFollow,
        label: 'Do Follow',
    },
    {
        value: LinkTypeEnum.NoFollow,
        label: 'No Follow',
    },
    {
        value: LinkTypeEnum.Sponsored,
        label: 'Sponsored',
    },
];


export enum MediaTypeEnum {
    Newspaper = 0,
    Blog = 1,
}

export const MEDIA_TYPE_OPTIONS: {
    value: MediaTypeEnum;
    label: string;
}[] = [
    {
        value: MediaTypeEnum.Newspaper,
        label: 'Periódico',
    },
    {
        value: MediaTypeEnum.Blog,
        label: 'Blogs/Revista',
    },
];

export enum CurrencyEnum {
    EUR = 0,
    GBP = 1,
    USD = 2,
}

export const CURRENCY_OPTIONS: {
    value: CurrencyEnum;
    label: string;
    symbol: string;
}[] = [
    {
        value: CurrencyEnum.EUR,
        label: 'EUR',
        symbol: '€',
    },
    {
        value: CurrencyEnum.GBP,
        label: 'GBP',
        symbol: '£',
    },
    {
        value: CurrencyEnum.USD,
        label: 'USD',
        symbol: '$',
    },
];

export enum MediaEditorStatusEnum {
    PendingVerification = 0,
    Active = 1,
    Inactive = 2,
}

export const MEDIA_EDITOR_STATUS_OPTIONS: {
    value: MediaEditorStatusEnum;
    label: string;
}[] = [
    {
        value: MediaEditorStatusEnum.PendingVerification,
        label: 'Pendiente de Verificación',
    },
    {
        value: MediaEditorStatusEnum.Active,
        label: 'Activo',
    },
    {
        value: MediaEditorStatusEnum.Inactive,
        label: 'Inactivo',
    },
];
